import React from 'react';
import { Link } from 'react-router-dom';

function Breadcrumb({ article }) {
    return (
        <nav className="breadcrumb" aria-label="breadcrumb">
            <ol>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/blog">Blog</Link></li>
                {article && (
                    <>
                        <li><Link to={`/blog?category=${article.category}`}>{article.category}</Link></li>
                        <li aria-current="page">{article.title}</li>
                    </>
                )}
            </ol>
        </nav>
    );
}

export default Breadcrumb; 